import { api } from "./client";

export type SupplyInventory = {
  id: number;
  stockQuantity: number;
  weightedAvgCost: number;
};

export type SupplyRestock = {
  quantity: number;
  totalCost: number;
};

export const suppliesApi = {
  getBags: () => api.get<SupplyInventory>("/api/bags"),
  restockBags: (data: SupplyRestock) => api.post<SupplyInventory>("/api/bags/restock", data),
  getCards: () => api.get<SupplyInventory>("/api/cards"),
  restockCards: (data: SupplyRestock) => api.post<SupplyInventory>("/api/cards/restock", data),
};
